if (window.location.protocol !== 'https:') {
    window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
}

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import UAParser from 'ua-parser-js';
import Bowser from 'bowser';

// import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.darkmoon.css';

// import '@blueprintjs/icons/lib/css/blueprint-icons.css';
// import '@blueprintjs/core/lib/css/blueprint.css';
// import '@blueprintjs/popover2/lib/css/blueprint-popover2.css';


import { locale, loadMessages } from 'devextreme/localization';
import dxMessagesHU from 'devextreme/localization/messages/hu.json';

import './i18n';

const pdfjsLib = require('pdfjs-dist/build/pdf');
import pdfjsWorker from 'worker-loader!../node_modules/pdfjs-dist/build/pdf.worker';


pdfjsLib.GlobalWorkerOptions.workerPort = new pdfjsWorker();
pdfjsLib.GlobalWorkerOptions.workerPort.onerror = (err) => {
    console.log('err', err)
}
pdfjsLib.GlobalWorkerOptions.workerPort.onmessage = (msg) => {
}

import { AuthProvider } from './contexts/auth';
import { A360Provider } from './contexts/a360';
import { ConfigProvider } from './contexts/config';

import store from './store'
import App from './App'

loadMessages(dxMessagesHU);
locale("en");

if (__VISUELSE__)
    document.title = "Visuelse Dashboard";
else if (__BIMLENS__)
    document.title = "BIMLens Viewer";
else
    document.title = "PanoWeb Manager";

const uap = new UAParser();

window.deviceType = uap.getDevice()?.type ?? 'desktop';
window.isTablet = window.deviceType === UAParser.DEVICE.TABLET ||
                  window.deviceType === UAParser.DEVICE.MOBILE;
window.isDesktop = !window.isTablet; // && window.deviceType === 'desktop';

let a360Credentials;
if (__DEVELOPMENT__)
    a360Credentials = {
        client_id:'TJ7Lel8mBXnIxRAG6PlJ5Z9Kl0P9VDmy',
        client_secret:'Qapi5llW1ABMIuAI',
        redirect_uri: encodeURI("https://192.168.1.111:9339/a360callback.html")
    };
else
    a360Credentials = {
        client_id:'FQ162TAY5vlm4YmTtRUFNga96v2KLGOH',
        client_secret:'w5qj7rl6UIZNAD99',
        redirect_uri: encodeURI("https://bimlens.logickft.hu/viewer/a360callback.html")
    };
    // a360Credentials = {
    //     client_id:'PQ75ULbsnTGBG0MeeZNYUpTmY5A9SvPd',
    //     client_secret:'ygejKJHfsNya79Dl',
    //     redirect_uri: encodeURI("https://dev.logickft.hu/builder/dashboard2/a360callback.html")
    // };

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConfigProvider>
                <AuthProvider>
                    <A360Provider a360Credentials={a360Credentials}>
                        <App/>
                    </A360Provider>
                </AuthProvider>
            </ConfigProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById("app")
);
